import createReducer from '../../utils/createReducer';
import {
  GET_FUNDING_SOURCE_SUCCESS,
  GET_FUNDING_SOURCE_ERROR,
  APPLICATION_FUNDING_SOURCE_SUCCESS,
  APPLICATION_FUNDING_SOURCE_ERROR,
  GET_FUNDING_SOURCE_ACCOUNT_DETAILS_SUCCESS,
  GET_FUNDING_SOURCE_ACCOUNT_DETAILS,
  GET_FUNDING_SOURCE_ACCOUNT_DETAILS_ERROR,
  GET_FUNDING_ACCOUNT_PURPOSE_SUCCESS,
  GET_FUNDING_ACCOUNT_PURPOSE_ERROR,
  GET_FUNDING_ACCOUNT_PURPOSE,
} from '../../actions/fundingSource/FundingSourceConstants';

const initialState = {
  fundingsources: [],
  accountPurposes: [],
  applicationFunding: {},
  accountDetails: {},
  error: '',
  loading: false,
};

export default createReducer(
  {
    [GET_FUNDING_ACCOUNT_PURPOSE]: startFetchingFundingPurpose,
    [GET_FUNDING_SOURCE_ACCOUNT_DETAILS]: startFetchingAccountDetails,
    [GET_FUNDING_SOURCE_SUCCESS]: getFundingSource,
    [GET_FUNDING_SOURCE_ERROR]: getFundingSourceError,
    [APPLICATION_FUNDING_SOURCE_SUCCESS]: applicationFundingSourceSuccess,
    [APPLICATION_FUNDING_SOURCE_ERROR]: applicationFundingSourceError,
    [GET_FUNDING_SOURCE_ACCOUNT_DETAILS_SUCCESS]: setFundingAccountDetails,
    [GET_FUNDING_ACCOUNT_PURPOSE_SUCCESS]: getFundingPurposeSource,
    [GET_FUNDING_ACCOUNT_PURPOSE_ERROR]: getFundingPurposeSouceError,
    [GET_FUNDING_SOURCE_ACCOUNT_DETAILS_ERROR]: getAccountDetailsError,
  },
  initialState,
);

function startFetchingFundingPurpose(state) {
  return {
    ...state,
    loading: true,
    error: '',
  };
}

function startFetchingAccountDetails(state) {
  return {
    ...state,
    loading: true,
    error: '',
  };
}

function getAccountDetailsError(state, { payload }) {
  return {
    ...state,
    error: payload,
    loading: false,
  };
}

function getFundingSource(state, { payload }) {
  return {
    ...state,
    fundingsources: payload,
    error: '',
    loading: false,
  };
}

function getFundingSourceError(state, { payload }) {
  return {
    ...state,
    error: payload,
    loading: false,
  };
}

function getFundingPurposeSource(state, { payload }) {
  return {
    ...state,
    accountPurposes: payload,
    error: '',
    loading: false,
  };
}

function getFundingPurposeSouceError(state, { payload }) {
  return {
    ...state,
    error: payload,
    loading: false,
  };
}

function applicationFundingSourceSuccess(state, action) {
  return {
    ...state,
    applicationFunding: action.payload,
    error: '',
    loading: false,
  };
}

function applicationFundingSourceError(state, action) {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
}

function setFundingAccountDetails(state, action) {
  return {
    ...state,
    accountDetails: { ...action.payload },
    loading: false,
  };
}
